import { render, staticRenderFns } from "./checkBox.vue?vue&type=template&id=4e5b59c0&scoped=true&"
import script from "./checkBox.vue?vue&type=script&lang=js&"
export * from "./checkBox.vue?vue&type=script&lang=js&"
import style0 from "./checkBox.vue?vue&type=style&index=0&id=4e5b59c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b59c0",
  null
  
)

export default component.exports